module.exports = __webpack_public_path__ + "static/media/proposition_2.cc5182d9.svg";